<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <v-card style="border-radius: 12px; overflow: hidden;">

      <div class="dialog-header">
        <v-icon color="white" class="mr-2">mdi-book-check-outline</v-icon>
        <div>
          <div class="dialog-header-title">Autorizar Devolução</div>
          <div class="dialog-header-subtitle">Autorizar devolução parcial de e-book</div>
        </div>
      </div>

      <v-card-text class="pt-5 pb-3">
        <div v-if="item" class="info-grid mb-5">
          <div class="info-item">
            <span class="info-label">Nº Pedido</span>
            <span class="info-value info-value--pedido">#{{ item.idorcamento }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Filial</span>
            <span class="info-value">{{ item.empresa || item.idempresa }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Cliente</span>
            <span class="info-value">{{ item.nomecliente }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Combo</span>
            <div>
              <v-chip x-small :color="corCombo(item.combo)" dark style="font-weight: 600;">
                {{ item.combo }}
              </v-chip>
            </div>
          </div>
          <div class="info-item">
            <span class="info-label">Valor E-book</span>
            <span class="info-value info-value--destaque">{{ item.valorebook | formataDinheiro }}</span>
          </div>
          <div class="info-item">
            <span class="info-label">Data do Pedido</span>
            <span class="info-value">{{ item.dtpedido | formataData }}</span>
          </div>
        </div>

        <v-textarea
          v-model="observacao"
          label="Observação / Justificativa *"
          outlined
          dense
          rows="3"
          :rules="[v => (!!v && v.trim().length > 0) || 'Observação é obrigatória']"
          :disabled="salvando"
          counter="500"
          maxlength="500"
          style="border-radius: 8px;"
          placeholder="Descreva o motivo da autorização de devolução..."
        />
      </v-card-text>

      <v-card-actions class="px-5 pb-4 dialog-actions">
        <v-btn text :disabled="salvando" @click="fechar">Cancelar</v-btn>
        <v-btn
          color="primary"
          elevation="0"
          :loading="salvando"
          :disabled="!observacaoValida"
          style="border-radius: 8px;"
          @click="confirmar"
        >
          <v-icon left small>mdi-check-circle-outline</v-icon>
          Confirmar Autorização
        </v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DialogAutorizaDevolucao',
  props: {
    value:    { type: Boolean, default: false },
    item:     { type: Object,  default: null  },
    salvando: { type: Boolean, default: false },
  },
  data: () => ({
    observacao: '',
  }),
  computed: {
    dialog: {
      get() { return this.value },
      set(v) { this.$emit('input', v) },
    },
    observacaoValida() {
      return this.observacao && this.observacao.trim().length > 0
    },
  },
  watch: {
    value(aberto) {
      if (!aberto) this.observacao = ''
    },
  },
  methods: {
    fechar() {
      this.$emit('input', false)
    },
    confirmar() {
      this.$emit('confirmar', this.observacao.trim())
    },
    corCombo(combo) {
      const cores = {
        'VIP':      'blue darken-1',
        'BRONZE':   'brown',
        'PRATA':    'blue-grey',
        'OURO':     'amber darken-2',
        'DIAMANTE': 'cyan darken-2',
      }
      return cores[combo] || 'primary'
    },
  },
}
</script>

<style scoped>
.dialog-header {
  padding: 16px 20px;
  display: flex;
  align-items: center;
  background: linear-gradient(135deg, #023449 0%, #035878 100%);
}
.dialog-header-title {
  color: white;
  font-size: 16px;
  font-weight: 700;
  line-height: 1.2;
}
.dialog-header-subtitle {
  color: rgba(255, 255, 255, 0.7);
  font-size: 12px;
  margin-top: 2px;
}

.info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 14px 20px;
}
.info-item {
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.info-label {
  font-size: 10px;
  color: #8fa8bc;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.4px;
}
.info-value {
  font-size: 13px;
  color: #3d5166;
  font-weight: 500;
}
.info-value--pedido {
  font-size: 15px;
  font-weight: 700;
  color: #023449;
}
.info-value--destaque {
  font-size: 15px;
  font-weight: 700;
  color: #023449;
}

.dialog-actions {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
  gap: 8px;
}
</style>
